import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/components/home/hero-section.js");
import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/components/home/search-section.js");
import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/components/home/stock-section.js");
import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/components/home/tesimonial-section.js")